module.exports = __webpack_public_path__ + "media/images/admin-user-eafc49f5f1b4c3e457da91d2db7fea73.jpg";